import React from 'react'

export const YOMA_ICON_STROKE = '#8B7361'
export const YOMA_ICON_GOLD = '#C09A5B'
export const YOMA_STROKE_WIDTH = '1.5'

export const ICONS = {
  clipboard: (
    <svg width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke={YOMA_ICON_STROKE}
      strokeWidth={YOMA_STROKE_WIDTH}
      strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="2" width="6" height="4" rx="1" />
      <path d="M8 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2h-2" />
      <line x1="8" y1="10" x2="16" y2="10" />
      <line x1="8" y1="14" x2="16" y2="14" />
      <line x1="8" y1="18" x2="12" y2="18" />
    </svg>
  ),

  finance: (
    <svg width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke={YOMA_ICON_GOLD}
      strokeWidth={YOMA_STROKE_WIDTH}
      strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v8" />
      <path d="M9.5 10.5c0-1 1-1.5 2.5-1.5s2.5.5 2.5 1.5-1 1.5-2.5 1.5-2.5.5-2.5 1.5 1 1.5 2.5 1.5 2.5-.5 2.5-1.5" />
    </svg>
  ),

  calendar: (
    <svg width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke={YOMA_ICON_STROKE}
      strokeWidth={YOMA_STROKE_WIDTH}
      strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <path d="M3 10h18" />
    </svg>
  ),

  building: (
    <svg width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke={YOMA_ICON_STROKE}
      strokeWidth={YOMA_STROKE_WIDTH}
      strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="3" width="14" height="18" rx="1.5" />
      <path d="M9 7h.01" />
      <path d="M15 7h.01" />
      <path d="M9 11h.01" />
      <path d="M15 11h.01" />
      <path d="M10 21v-4h4v4" />
    </svg>
  ),

  folder: (
    <svg width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke={YOMA_ICON_STROKE}
      strokeWidth={YOMA_STROKE_WIDTH}
      strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
    </svg>
  ),

  checkSeal: (
    <svg width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke={YOMA_ICON_GOLD}
      strokeWidth={YOMA_STROKE_WIDTH}
      strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="8" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  )
}